import { selector } from "recoil";

import { LiveMapDisplayModeEnum } from "../../enums";
import { resolveLiveMapDisplayMode } from "../../helpers";
import { liveMapDisplayModeOverrideAtom } from "../atoms";
import { systemSettingsDtoAtom } from "../atoms/system-settings.atoms";

/** Effective live-map display mode for the current session. */
export const liveMapEffectiveDisplayModeSelector =
  selector<LiveMapDisplayModeEnum>({
    key: "liveMapEffectiveDisplayModeSelector",
    get: ({ get }) => {
      const override = get(liveMapDisplayModeOverrideAtom);
      const settings = get(systemSettingsDtoAtom);

      return resolveLiveMapDisplayMode({
        overrideValue: override,
        systemParamValue: settings?.metadata?.ridesMapDefaultDisplayMode,
      });
    },
  });
